import { CSSProperties } from 'react'

import { media } from 'shared/lib'
import FlightClubLogoSVG from 'shared/svg/flightclub_logo.svg'
import { colors } from 'shared/theme'
import styled from 'styled-components'

export const FlightClubLogoIcon = ({
  className,
  style,
}: {
  className?: string
  style?: CSSProperties
}) => {
  return (
    <CustomSvg
      className={className}
      style={style}
      viewBox="0 0 87 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Union"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.113 9.21497H26.1063L26.8746 5.73612H31.259L29.1264 15.4557C28.027 15.8407 26.9408 15.8938 25.9209 15.8938C22.477 15.8938 21.3113 14.2075 21.3113 11.127C21.3113 8.75024 22.2518 5.09877 23.6161 3.13362C25.0731 1.03569 26.9673 0 29.6032 0C30.239 0 31.3252 0.172615 31.9743 0.331951C31.8828 0.746934 31.7826 1.204 31.6813 1.6662L31.6786 1.67823L31.6777 1.6823L31.6773 1.68408C31.5011 2.48797 31.3218 3.30591 31.1795 3.94358C30.5702 3.77097 29.8549 3.63819 29.1661 3.5718C28.3581 3.50541 26.9541 3.78425 26.1726 5.51039C24.8612 8.40501 24.4241 12.3353 25.9341 12.3353C26.2123 12.3353 26.464 12.1893 26.5434 11.8175L27.113 9.21497ZM10.834 0.132739L10.1054 3.50536H6.92644L6.40985 5.88213H9.57561L8.8206 9.33443H5.65483L4.25076 15.7743H0.714111L4.1448 0.132739H10.834ZM15.6158 15.7743L19.0465 0.132739H22.5699L19.1524 15.7743H15.6158ZM12.6615 12.4813L15.3636 0.132739H11.8402L8.40955 15.7743H14.7543L15.4829 12.4813H12.6615ZM37.1008 5.74935L38.3326 0.132739H41.856L38.4386 15.7743H34.9152L36.3457 9.2282H34.9284L33.4979 15.7743H29.9745L33.3919 0.132739H36.9153L35.6967 5.74935H37.1008ZM42.7297 0.132739L41.935 3.73109H43.8159L41.1932 15.7743H44.7166L47.3525 3.73109H49.1142L49.8957 0.132739H42.7297ZM63.0091 12.4813L65.7113 0.132739H62.1879L58.7572 15.7743H65.102L65.8173 12.4813H63.0091ZM73.9086 2.44522L74.4148 0.132739H77.8984C77.0772 3.87715 75.6201 10.5693 75.3287 11.9104C74.9181 13.8091 74.0704 14.5793 73.3154 15.1369C72.5603 15.7079 71.6861 16 69.9906 16C69.2621 16 68.2024 15.9469 67.4342 15.3096C66.8116 14.7917 66.1891 13.995 66.7057 11.6315L67.0582 10.0252C67.6453 7.35059 68.6641 2.70899 69.2224 0.132739H72.7061C72.3857 1.59465 71.979 3.4528 71.5876 5.24122L71.586 5.24864L71.5843 5.25632L71.5825 5.26443C70.8916 8.42149 70.2496 11.3549 70.2158 11.4988C70.0966 12.083 70.2158 12.4282 70.8251 12.4282C71.355 12.4282 71.7523 12.2954 71.9245 11.4988C72.0235 11.0579 73.0351 6.43622 73.9063 2.4557L73.9086 2.44522ZM83.4615 0.132739C85.5809 0.132739 86.4419 1.0622 86.4419 2.60246C86.4419 4.48794 85.6074 6.37342 84.3623 7.14355C84.5874 7.38255 85.1967 8.03318 85.1967 9.26804C85.1967 10.9278 84.455 13.9552 82.5608 15.1104C81.5541 15.7212 80.6666 15.7743 78.4678 15.7743H75.408L78.8387 0.132739H82.2562H83.4615ZM81.4743 5.81586H81.0107L81.5802 3.22664H82.0173C82.6002 3.22664 82.7326 3.79759 82.7326 4.08971C82.7459 4.87312 82.2558 5.81586 81.4743 5.81586ZM81.2093 11.5388C81.0636 12.0566 80.6662 12.4549 80.1231 12.4549H79.5535L80.2821 9.10887H80.8516C81.3285 9.10887 81.5537 9.50721 81.5537 9.86572C81.5537 10.2109 81.355 11.0607 81.2093 11.5388ZM54.3866 2.56262C55.8569 0.238959 57.7245 0.0132324 59.0094 0.0132324C59.8174 0.0132324 60.6386 0.106179 61.089 0.159291L60.281 3.83731C60.2514 3.83156 60.2215 3.82573 60.1913 3.81984C59.3865 3.66272 58.414 3.47285 57.7245 4.0232C57.0863 4.53759 56.8855 5.2535 56.6754 6.00292C56.6631 6.04665 56.6508 6.09049 56.6384 6.13441C56.3602 7.13027 56.0158 8.69708 55.8436 9.71949C55.6714 10.7552 55.539 11.9369 56.9165 12.0564C57.5126 12.0963 58.2941 12.0697 58.6518 12.0431L57.8305 15.761C57.6981 15.7876 57.2344 15.854 56.5854 15.854C54.7177 15.854 52.1083 15.5884 52.1083 12.0431C52.1083 10.3701 53.2474 4.36843 54.3866 2.56262Z"
        fill="#E91C23"
      />
    </CustomSvg>
  )
}

const CustomSvg = styled.svg`
  flex-shrink: 0;
  height: 14px;
  width: 75px;

  ${media.medium`
    height: 16px;
    width: 86px;
  `}
`

const FlightClubLogo = styled(FlightClubLogoSVG)`
  color: ${colors.red};
  height: 24px;
  width: 127px;
`

export default FlightClubLogo
